import React from "react";

export default function EmptySpace({ item }) {
  return (
    <div
      style={{
        height: item.emptySpaceHeightPx + "px",
        width: "100%",
        clear: "both",
      }}
    ></div>
  );
}
